export default "__VITE_ASSET__173bb8df__"